import * as React from "react";

import { Button } from "@livechat/design-system";

import { navigate } from "helpers/routing";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href: string;
}

export const LinkButton: React.FC<IProps> = ({ href, children, ...props }) => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  const handleClick = (event: any) => {
    if (href) {
      navigate(href);
    }

    return props.onClick && props.onClick(event);
  };

  return (
    <Button size="large" kind="primary" {...props} onClick={handleClick}>
      {children}
    </Button>
  );
};
